import { helper } from '@ember/component/helper';

const HUE_NAME = /^[a-z]+$/;

// Tag colours are the hue token names in framework `boardTags.colors`. Anything else gets no fill:
// `<ui-icon>` interpolates the value into its SVG markup unescaped.
export function tagColor(color: string | undefined): string | undefined {
	return color && HUE_NAME.test(color) ? `var(--hue-${color})` : undefined;
}

export default helper(([color]: [string | undefined]) => tagColor(color));
